<script>
import ArticleLogos from '@/components/Articles/ArticleLogos.vue';
import SectionCompanies from '~/components/HomePageComponents/SectionCompanies';
import ArticleTip from '@/components/Articles/ArticleTip';


export default {
  components: {
    ArticleLogos,
    SectionCompanies,
    ArticleTip,
  },
  props: {
    showCategoryTitle: {
      type: Boolean,
      required: false,
      default: true,
    },
    showCategoryName: {
      type: Boolean,
      required: false,
      default: true,
    },
    items: {
      required: false,
      default: () => [],
    },
    breakFooter: {
      type: Boolean,
      required: false,
      default: false,
    },
    logosTitle: {
      type: String,
      required: false,
      default: '',
    },
    highlight: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
